<style lang="scss" scoped>
.adhese ::v-deep img {
    @apply w-full h-auto sm:w-auto;
}
</style>

<template>
    <div class="adhese" :class="{ 'extend-container': extendContainer }" ref="adhese" :data-adhese-domain="adhesePosition" :data-adhese-format="adheseFormat" :data-adhese-position="language" :data-adhese-pagetype="adhesePagetype"></div>
</template>

<script>
export default {
    props: {
        extendContainer: {
            type: Boolean,
            required: false,
            default: false,
        },
        adheseIndex: {
            type: String,
            required: true,
        },
        pageType: {
            type: String,
            required: false,
        },
        environment: {
            type: String,
            required: true,
        },
    },

    mounted() {
        const script = document.createElement('script');
        script.src = 'https://pool-bionic.adhese.com/tag/ad.js';
        this.$refs.adhese.appendChild(script);
    },

    computed: {
        adheseFormat() {
            return window.innerWidth < 768 ? '300x250' : '970x250';
        },

        adhesePosition() {
            if (this.environment !== 'production') {
                return 'test.com';
            }

            return window.innerWidth < 768 ? `bionic_pascale_neassens_mw_pos${this.adheseIndex}` : `bionic_pascale_neassens_dt_pos${this.adheseIndex}`;
        },

        language() {
            // return the lang from the html tag
            return document.documentElement.lang;
        },

        adhesePagetype() {
            if (this.pageType != null && this.pageType !== '') {
                return this.pageType;
            }
            if (document.body.classList.contains('product.show-detail')) {
                return 'product';
            }
            if (document.body.classList.contains('recipe.show')) {
                return 'recipe';
            }
            if (document.body.classList.contains('blog.show')) {
                return 'blog';
            }
            return '';
        },
    },
};
</script>
